import PaymentsStyledInput from '@components/system/FormInput/PaymentsStyledInput';
import EmailIcon from '@components/system/MyIcons/EmailIcon';
import {
  Button,
  Card,
  CardContent,
  createStyles,
  FormControl,
  FormHelperText,
  InputAdornment,
  makeStyles,
  Theme,
  Typography
} from '@material-ui/core';
import {emailValidationWithHookForm} from '@shared/modules/payments/login/Login';
import React, {ReactElement} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import NavRoutes from 'src/constants/route/NavRoutes';
import {APP, BLACK_COLOR, GET_8_PIXEL_BOX} from 'src/style/variable';
import BackNavigation from '../backNavigation/BackNavigation';

// styles
import './SendEmailStyles.scss';
import {useSnackbar} from 'notistack';
import Loader from '@components/framework/loader/Loader';
import {sendReminderEmail} from '@shared/services/Payment.service';
import {SnackBarConfig} from '../../../utils/SnackBarConfig';
import {connect, useSelector} from 'react-redux';
import {_guarantorLogin} from '@shared/store/actions/PaymentActions';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginButton: {
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '2.7rem'
    },
    card: {
      borderRadius: 0,
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      boxShadow: 'none'
    },
    cardPadding: {
      '& .MuiCardContent-root': {
        padding: 0
      },
      padding: 0
    },
    fieldText: {
      display: 'flex',
      color: BLACK_COLOR,
      paddingBottom: '0.5rem',
      justifyContent: 'flex-start',
      fontSize: '1.2rem'
    }
  })
);

const SendEmail = (props: any): ReactElement => {
  const classes = useStyles();
  const {history, match} = props;
  const {t} = useTranslation();
  const token = match.params.token;
  const {enqueueSnackbar} = useSnackbar();
  const [loader, setLoader] = React.useState<boolean>(false);
  const isLogin = useSelector((state: any) => state.payments.isLogin);

  const backNavigation = (): void => {
    history.push(`/${NavRoutes.PUBLIC.PAYMENTS_DASHBOARD}/${token}`);
  };

  const {control, handleSubmit, errors} = useForm<{email: string}>({
    mode: 'all',
    resolver: async values => {
      return {values, errors: emailValidationWithHookForm(values)};
    }
  });

  React.useEffect(() => {
    if (!isLogin) {
      props._guarantorLogin(false);
      if (token) {
        history.push(`/${NavRoutes.PUBLIC.PAYMENTS_LOGIN}/pay/${token}`);
      }
      return;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFormSubmit = async (values: any) => {
    setLoader(true);
    sendReminderEmail({email_id: values.email})
      .then(res => {
        if (res.message) {
          enqueueSnackbar(res.message, SnackBarConfig('s'));
        }
        backNavigation();
      })
      .catch(err => {
        enqueueSnackbar(err.message || t('APP.ERROR'), SnackBarConfig('e'));
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <div className="send-email-wrapper">
      <Card className={['send-email-content-wrap', classes.card].join(' ')}>
        <CardContent className={[classes.cardPadding, 'content'].join(' ')}>
          <div className="send-email-content-view">
            <Typography className="details-view" component={'div'}>
              <BackNavigation navigateTo={backNavigation} />
            </Typography>
            <Typography className="info-text input-header" component={'div'}>
              {t('PAYMENTS_LOGIN.SEND_MAIL.EMAIL_TEX')}
            </Typography>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
              <div className={classes.fieldText}>
                {t('PAYMENTS_LOGIN.SEND_MAIL.TITLE')}*
              </div>
              <FormControl
                error={!!errors.email}
                fullWidth={true}
                variant="outlined">
                <Controller
                  id="email"
                  as={PaymentsStyledInput}
                  control={control}
                  name={'email'}
                  type={'email'}
                  value={'email'}
                  autoComplete="on"
                  placeholder={t('PAYMENTS_LOGIN.PLACEHOLDERS.EMAIL')}
                  defaultValue=""
                  error={!!errors.email}
                  startAdornment={
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  }
                  style={{height: '3.5rem'}}
                />
                {errors.email && (
                  <FormHelperText style={{color: 'red'}}>
                    {t(errors.email as any)}
                  </FormHelperText>
                )}
              </FormControl>
            </form>
          </div>
          <div className="buttonView">
            <Button
              fullWidth
              variant="contained"
              size={'medium'}
              color="primary"
              className={[classes.loginButton].join(' ')}
              type={'submit'}
              disabled={loader}
              style={{height: '3.5rem'}}
              onClick={handleSubmit(handleFormSubmit)}>
              {loader ? <Loader /> : t('PAYMENTS_LOGIN.DASHBOARD.SEND_LINK')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
export default connect(
  () => {
    return {};
  },
  {
    _guarantorLogin
  }
)(SendEmail);
